'use client';
 
import React from 'react';
import styles from '../../publicWebsite/trackApplication/TrackApplicationCard.module.css';
import type { TrackerCardStudent } from '@/models/api/studentRegistration';
 
interface ApplicationTrackerProps {
  students: TrackerCardStudent[];
  onStudentClick?: (studentId: string | number) => void;
   visitDetails?: {
    message?: string;
    title?: string;
    location?: string;
    scheduledDate?: string;
    contactPerson?: string;
    instructions?: string;
  };
}
 
const ApplicationTracker: React.FC<ApplicationTrackerProps> = ({
  students,
  onStudentClick,
}) => {
  
 
 
  const handleCardClick = (studentId: string | number) => {
  console.log("🟢 Clicked Student ID:", studentId);
  onStudentClick?.(studentId);
};
 
  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLElement>,
    studentId: string | number
  ) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleCardClick(studentId);
    }
  };
 
  return (
    <section className={styles.container} aria-label="Application Tracker">
      <header className={styles.header}>
        <h1 className={styles.title}>Application Tracker</h1>
        <p className={styles.subtitle}>
          Track the status of your child&apos;s admission in real-time.
        </p>
      </header>
 
      <hr className={styles.separator} />
 
      <div className={styles.cardsContainer}>
        {students.length === 0 ? (
          <div className={styles.noStudents}>No student applications found.</div>
        ) : (
          students.map((student) => (
            <article
              key={student.id}
              className={styles.card}
              onClick={() => handleCardClick(student.id)}
              onKeyDown={(e) => handleKeyDown(e, student.id)}
              role="button"
              tabIndex={0}
              aria-label={`View details for ${student.name}`}
            >
              <h2 className={styles.studentName}>{student.name}</h2>
              <div className={styles.studentDetails}>
                <p className={styles.detailText}>
                  <span className={styles.detailLabel}>Entry Year: </span>
                  {student.entryYear}
                </p>
                <p className={styles.detailText}>
                  <span className={styles.detailLabel}>Applying Course: </span>
                  {student.courseCode}
                </p>
                <p className={styles.detailText}>
                  <span className={styles.detailLabel}>Date Of Birth: </span>
                  {student.dateOfBirth}
                </p>
               
              </div>
            </article>
          ))
        )}
      </div>
    </section>
  );
};
 
export default ApplicationTracker;
 